
import './index.less'
import React from 'react'
import 'swiper/css/swiper.css'
import Smooth from './smooth.jsx'
import Center from './center.jsx'
import FadeInFadeOut from './fadeInFadeOut.jsx'
import Rotate3D from './3Drotate.jsx'
import Rol3D from './3Drol.jsx'
console.log(React)

export default function TopRotation(props) {
  return (<div className={`TopRotation ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}>
    {props.ifon.image_id_list.length ? null : <div className='TopRotation_div1'>
      <img src='https://read.e.qq.com/assets/images/yuebao/icon_upload_back.png' className='img' />
    </div>}

    {props.ifon.image_id_list.length ? <div className='TopRotation_box' style={{
      backgroundColor: props.ifon.backType === 1 ? 'transparent' : props.ifon.back,
      backgroundImage: props.ifon.backType === 1 && `url(${props.ifon.backImage.src})`,
      paddingTop: props.ifon.paddingTop,
      paddingBottom: props.ifon.paddingBottom,
      paddingLeft: props.ifon.paddingLeft,
      paddingRight: props.ifon.paddingRight
    }}>
      {exhibition(props)}
    </div> : null}
    <div className='Mantle1'></div>
  </div>)
}

function exhibition(props) {
  const type = props.ifon.type
  if (type === 0) {
    return <Smooth ifon={props.ifon} key={props.ifon.image_id_list.length} playbackSpeed={props.ifon.playbackSpeed}></Smooth>
  } else if (type === 1) {
    return <Center ifon={props.ifon} key={props.ifon.image_id_list.length} playbackSpeed={props.ifon.playbackSpeed}></Center>
  } else if (type === 2) {
    return <FadeInFadeOut ifon={props.ifon} key={props.ifon.image_id_list.length} playbackSpeed={props.ifon.playbackSpeed}></FadeInFadeOut>
  } else if (type === 3) {
    return <Rotate3D ifon={props.ifon} key={props.ifon.image_id_list.length} playbackSpeed={props.ifon.playbackSpeed}></Rotate3D>
  } else if (type === 4) {
    return <Rol3D ifon={props.ifon} key={props.ifon.image_id_list.length} playbackSpeed={props.ifon.playbackSpeed}></Rol3D>
  }
}
